<template>
  <div
    class="
      cbg-white-container
      blog-listing-main
      cme-blog
      input-container
      theme--light
      v-card
      p-16
      border-card
      pt-0
    "
  >
    <v-tabs
      v-model="tabs"
      background-color="transparent"
      class="border-bottom theme-light v-card"
    >
      <v-tab v-for="(item, i) in items" :key="i">{{ item.tabName }}</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tabs">
      <v-tab-item>
        <div v-if="tabs == 0">
          <div class="user-blog-box mt-6">
            <div class="col-sm-12 row ml-0 pl-0 pr-0">
              <div class="row">
                <CCol sm="6" md="3" class="sm-boxes">
                  <label for>Search</label>
                  <div class="search-div position-relative">
                    <input
                      @input="debounceSearch()"
                      class="form-control"
                      placeholder="Search"
                      v-model="search"
                    />

                    <div
                      v-if="search !== ''"
                      class="search-svg position-absolute"
                      @click="clearSearch()"
                    >
                      <crossSVG />
                    </div>
                  </div>
                </CCol>
                <CCol sm="6" md="3" class="datepicker pos-r sm-boxes">
                  <label for>Date Range</label>
                  <datepicker
                    v-model="joinOnDateRange"
                    @input="dateChange()"
                    ref="datepicker"
                    :model-config="datePickerConfig"
                    is-range
                    :masks="{ input: 'DD/MM/YYYY' }"
                  >
                    <template v-slot="{ inputValue, inputEvents }">
                      <input
                        :value="
                          !!inputValue.start && !!inputValue.end
                            ? inputValue.start + ' - ' + inputValue.end
                            : 'DD/MM/YYYY'
                        "
                        v-on="inputEvents.start"
                        class="form-control pos-r"
                        placeholder="DD/MM/YYYY"
                      />
                      <div
                        v-if="!!inputValue.start && !!inputValue.end"
                        class="cross-svg"
                        @click="resetJoiningDate"
                      >
                        <crossSVG />
                      </div>
                    </template>
                  </datepicker>
                  <div class="calendarsvg userinputcalendar pos-a">
                    <calendarSVG />
                  </div>
                </CCol>
                <CCol sm="6" md="3" class="sm-boxes">
                  <div class="position-relative">
                    <label for>CME Status</label>
                    <select
                      name
                      id
                      class="form-control"
                      v-model="status"
                      @change="refreshlist()"
                    >
                      <option value>All</option>
                      <option value="pending">Awaiting Approval</option>
                      <option value="published">Published</option>
                      <option value="unpublished">Unpublished</option>
                      <option value="rejected">Rejected</option>
                      <option value="expired">Expired</option>
                      <option value="deleted">Deleted by user</option>
                    </select>
                    <span class="drop-icon">
                      <i
                        aria-hidden="true"
                        class="
                          v-icon
                          mdi mdi-menu-down
                          theme--light
                          position-absolute
                        "
                      ></i>
                    </span>
                  </div>
                </CCol>

                <CCol sm="6" md="3" class="sm-boxes">
                  <div class="position-relative">
                    <label for>Invitation For</label>
                    <select
                      name
                      id
                      class="form-control"
                      v-model="cmerole"
                      @change="refreshlist()"
                    >
                      <option value>All Events</option>
                      <option value="open">Open For All</option>
                      <option value="doctor">Doctor</option>
                      <option value="patient">Patient</option>
                      <option value="ambulance">Ambulance</option>
                      <option value="diagnostic">Diagnostics-Lab</option>
                      <option value="pharmacy">Pharmacy</option>
                      <option value="blood bank">Blood Bank</option>
                      <option value="vendor">Vendor</option>
                      <option value="hospital">Hospital</option>
                    </select>
                    <span class="drop-icon">
                      <i
                        aria-hidden="true"
                        class="
                          v-icon
                          mdi mdi-menu-down
                          theme--light
                          position-absolute
                        "
                      ></i>
                    </span>
                  </div>
                </CCol>

                <CCol
                  sm="6"
                  md="3"
                  class="sm-boxes d-block"
                  v-if="cmerole === 'doctor'"
                >
                  <div>
                    <label for>Speciality</label>
                    <select
                      name
                      id
                      class="form-control"
                      v-model="doctor_speciality"
                      @change="refreshlist()"
                    >
                      <option
                        v-for="(spec, index) in specialityList"
                        :value="spec.speciality_type"
                        :key="index"
                      >
                        {{ spec.speciality_type }}
                      </option>
                    </select>
                  </div>
                </CCol>
                <CCol sm="6" md="3" class="sm-boxes">
                  <div class="position-relative">
                    <label for>Credit Points</label>
                    <select
                      name
                      id
                      class="form-control"
                      v-model="cme_mmc_sort"
                      @change="refreshlist()"
                    >
                      <option value>All</option>
                      <option value="true">Yes</option>
                      <option value="false">No</option>
                    </select>
                    <span class="drop-icon">
                      <i
                        aria-hidden="true"
                        class="
                          v-icon
                          mdi mdi-menu-down
                          theme--light
                          position-absolute
                        "
                      ></i>
                    </span>
                  </div>
                </CCol>
                <CCol sm="6" md="2" class="sm-boxes">
                  <div class="position-relative">
                    <label for class="text-capitalize">Mode Of Event</label>
                    <select
                      name
                      id
                      class="form-control"
                      v-model="cme_mode"
                      @change="refreshlist()"
                    >
                      <option value>All</option>
                      <option value="online">Online</option>
                      <option value="offline">Offline</option>
                      <option value="hybrid">Hybrid</option>
                    </select>
                    <span class="drop-icon">
                      <i
                        aria-hidden="true"
                        class="
                          v-icon
                          mdi mdi-menu-down
                          theme--light
                          position-absolute
                        "
                      ></i>
                    </span>
                  </div>
                </CCol>
                <CCol sm="6" md="2" class="sm-boxes">
                  <div class="position-relative">
                    <label for>Charges</label>
                    <select
                      name
                      id
                      class="form-control"
                      v-model="cme_charge"
                      @change="refreshlist()"
                    >
                      <option value>All</option>
                      <option value="free">Free</option>
                      <option value="paid">Paid</option>
                    </select>
                    <span class="drop-icon">
                      <i
                        aria-hidden="true"
                        class="
                          v-icon
                          mdi mdi-menu-down
                          theme--light
                          position-absolute
                        "
                      ></i>
                    </span>
                  </div>
                </CCol>

                <CCol sm="6" md="1">
                  <label class="col-sm-12 mb-0 d-none-mob1" for></label>
                  <v-btn
                    v-if="exportCSV"
                    @click="downloadCsv()"
                    class="btn btn-primary mt-0"
                    >Export</v-btn
                  >
                </CCol>
              </div>
            </div>
            <!-- CME Blog Card Start -->
            <div
              v-if="cmeList.length > 0"
              class="col-sm-12 row ml-0 mt-8 p-0 userlistTable-typ1 mb-5"
            >
              <cmeCard
                v-for="(cme, i) in cmeList"
                :key="i"
                :cmeDetails="cme"
                @refreshList="getCMEList()"
              />
            </div>
            <!-- CME blog card End -->
            <div v-else-if="showLoader && cmeList.length === 0">
              <loader v-if="showLoader"></loader>
            </div>
            <div v-else-if="isEmpty">
              <h2 class="text-center pt-4 no-data-class">No Data Found</h2>
            </div>
            <pagination
              class="pagination-block"
              v-if="cmeList.length > 0"
              :recordPerPage="recordPerPage"
              :currentPage="currentPage"
              :total="total"
              @changePage="changePage"
            />
          </div>
        </div>
      </v-tab-item>
      <v-tab-item>
        <div v-if="tabs == 1">
          <cmeReports />
        </div>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>
<script>
import config from "@/config.js";
import debounce from "lodash/debounce";
import { mapGetters } from "vuex";
import "@/assets/scss/_blogs.scss";
const Datepicker = () => import("v-calendar/lib/components/date-picker.umd");
const cmeCard = () => import("@/views/cme/cmeCard.vue");
const cmeReports = () => import("@/views/cme/cmeReports.vue");
const loader = () => import("@/components/loader.vue");
const Image = () => import("@/components/image.vue");
import { pickSvg } from "@/views/SVG";
export default {
  props: {},
  computed: {
    ...mapGetters({
      permissions: "getPermissions",
    }),
  },
  data() {
    return {
      tabs: null,
      items: [{ tabName: "CME Listing" }, { tabName: "Reports" }],
      isEmpty: false,
      lastSeenDateRange: {},
      joinOnDateRange: { start: "", end: "" },
      dateRange: {
        start: "",
        end: "",
      },
      datePickerConfig: {
        start: {
          timeAdjust: "00:00:00",
        },
        end: {
          timeAdjust: "23:59:59",
        },
      },
      inactiveDays: { fromDateRange: 7, toDateRange: 1 },
      dateRangeActive: false,
      rejectModal: false,
      reasonModal: false,
      recordPerPage: 12,
      currentPage: 1,
      totalPage: 1,
      total: 0,
      cmeList: [],
      specialityList: [],
      status: "",
      search: "",
      showLoader: false,
      isEmpty: false,
      cmerole: "",
      cme_mmc_sort: "",
      cme_mode: "",
      cme_charge: "",
      doctor_speciality: "",
      exportCSV: true,
    };
  },
  mounted() {
    if (this.$route.params.tag) {
      this.search = this.$route.params.tag;
    }
    this.getCMEList();
    this.getSpecialitiesList();
  },
  components: {
    loader,
    cmeReports,
    cmeCard,
    Datepicker,
    "image-view": Image,
    pagination: () => import("@/views/common/Pagination"),
    ...pickSvg("crossSVG"),
  },
  methods: {
    refreshlist() {
      this.cmeList = [];
      this.getCMEList();
    },
    clearSearch() {
      this.search = "";
    },
    debounceSearch: debounce(function () {
      this.getCMEList();
    }, 500),
    getCmePath() {
      this.$router.push(`/cme-events`);
    },
    changePage(page) {
      this.currentPage = page.currentPage;
      this.getCMEList();
    },
    openReasonModal() {
      this.reasonModal = true;
    },
    openRejectModal() {
      this.rejectModal = true;
    },
    closeRejectModal() {
      this.rejectModal = false;
    },
    resetJoiningDate() {
      this.joinOnDateRange = { start: "", end: "" };
      this.getCMEList();
    },
    resetActiveDate() {
      this.lastSeenDateRange = {};
      if (this.durationFilter) {
        this.fromDate = dayjs().subtract(7, "d").toISOString();
        this.toDate = dayjs().subtract(0, "d").toISOString();
      }
      this.getUserList();
    },
    dateChange() {
      this.getCMEList();
    },
    getCMEList() {
      this.showLoader = true;
      this.total = 0;
      let url = `${config.BASE_URL}api/v2/admin/cme-events`;
      let params = {
        page: this.currentPage,
        records_per_page: this.recordPerPage,
        status: this.status,
        search: this.search,
        role: this.cmerole,
        mmc_sort: this.cme_mmc_sort,
        mode: this.cme_mode,
        charge: this.cme_charge,
        speciality: this.doctor_speciality,
        start_date: this.joinOnDateRange.start.toString(),
        end_date: this.joinOnDateRange.end.toString(),
      };
      this.$http.get(url, { params }).then((response) => {
        if (response.body.status) {
          this.showLoader = false;
          if (response.body.data.list.length) {
            this.cmeList = response.body.data.list;
            this.totalPage = response.body.data.count / this.recordPerPage;
            if (response.body.data.count % this.recordPerPage !== 0)
              this.totalPage = parseInt(JSON.stringify(this.totalPage)) + 1;
            this.total = response.body.data.count;
          } else {
            this.cmeList = [];
            this.isEmpty = true;
            this.exportCSV = false;
          }
        }
      });
    },
    getSpecialitiesList() {
      let url = `${config.BASE_URL}api/v2/doctor/master/specialities-complains`;
      this.$http.get(url).then((response) => {
        const { data } = response;
        if (data.status) {
          this.specialityList = data.data.specialities;
        }
      });
    },
    goTo(url) {
      this.$router.push(url);
    },
    downloadCsv() {
      this.showLoader = true;
      let params = {
        page: this.currentPage,
        records_per_page: this.recordPerPage,
      };
      let url = `${config.BASE_URL}api/v2/admin/cme-events-csv`;
      this.$http.get(url, { params }).then((response) => {
        if (response.body.status) {
          this.showLoader = false;
          const data = response.data.data;
          this.download(data.fileName, data.csv);
          console.log("heyboi", response);
        }
      });
    },
    download(filename, text) {
      var element = document.createElement("a");
      element.setAttribute(
        "href",
        "data:text/plain;charset=utf-8," + encodeURIComponent(text)
      );
      element.setAttribute("download", filename);

      element.style.display = "none";
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
    },
  },
};
</script>